import axios from "axios"
import { PDFDocument } from "pdf-lib"

export const fetchPDFData = async (pdfUrl) => {
  try {
    const response = await axios.get(pdfUrl, {
      responseType: 'blob',
      headers: { 'Accept': 'application/pdf' }
    })

    const contentDisposition = response.headers['content-disposition']
    let filename = 'doc.pdf' // filename por defecto

    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="(.+)"/)
      if (filenameMatch) {
        filename = filenameMatch[1]
      }
    }

    const pdf = await response.data.arrayBuffer()
    return { pdf, filename }

  } catch (error) {
    let msg = 'Error al obtener el PDF'
    if (error.response && error.response.data) {
      // si es un blob de error, convertir a texto
      if (error.response.data instanceof Blob) {
        try {
          const text = await error.response.data.text()
          const errorData = JSON.parse(text)
          msg = errorData.message || msg
        } catch {
          msg = 'Error al procesar la respuesta del servidor'
        }
      } else {
        msg = error.response.data.message || JSON.stringify(error.response.data)
      }
    } else if (error.message) {
      msg = error.message
    }
    throw new Error(msg)
  }
}

export const printPDFfromURL = async (pdfUrl) => {
  const response = await fetch(pdfUrl)
  const blob = await response.blob()

  const url = URL.createObjectURL(blob)
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url
  document.body.appendChild(iframe)

  iframe.onload = () => {
    iframe.contentWindow.focus()
    iframe.contentWindow.print()
    setTimeout(() => {
      URL.revokeObjectURL(url)
      document.body.removeChild(iframe)
    }, 60000)
  }
}

export const printPDF = (pdfContent) => {
  const blob = new Blob([pdfContent], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)

  // crear iframe oculto
  const iframe = document.createElement('iframe')
  iframe.style.display = 'none'
  iframe.src = url

  document.body.appendChild(iframe)

  // imprimir cuando se cargue
  iframe.onload = () => {
    iframe.contentWindow.focus()
    iframe.contentWindow.print()
    setTimeout(() => {
      URL.revokeObjectURL(url)
      document.body.removeChild(iframe)
    }, 60000)
  }
}

export const downloadPDF = (pdfContent, filename) => {
  const blob = new Blob([pdfContent], { type: 'application/pdf' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')

  link.href = url
  link.download = filename || 'doc.pdf'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)

  setTimeout(() => URL.revokeObjectURL(url), 100)
}

export const getPDFInfo = async (pdfContent) => {
  try {
    const pdfDoc = await PDFDocument.load(pdfContent)

    return {
      size: new Blob([pdfContent]).size,
      pageCount: pdfDoc.getPageCount(),
    }
  } catch (error) {
    return null
  }
}
